import Item, {ItemAttributes} from '~/shared/src/ci/Item';
import Reference, {ReferenceAttributes} from '~/shared/src/ci/Reference';

import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import addItem from '~/frontend/src/actions/data/addItem';
import addReference from '~/frontend/src/actions/data/addReference';


/**
 * @memberOf! Actions
 *
 * @param {String} dataContext
 * @param {Item|ItemAttributes} item
 * @param {Reference|ReferenceAttributes} reference
 * @param {Schema} schema
 * @param {string[]} [additionalElusiveDataContexts=[]]
 *
 * @return {AddItemAction}
 */
const addReferencedItem = ( dataContext : string, item : Item | ItemAttributes, reference : Reference | ReferenceAttributes, schema : Schema, additionalElusiveDataContexts : string[] = [] ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( addItem( dataContext, item, schema, additionalElusiveDataContexts ) );
    dispatch( addReference( dataContext, reference, schema, additionalElusiveDataContexts ) );
}
export type AddReferencedItem = typeof addReferencedItem;

export default addReferencedItem;
